<template>
  <div class="InvitEmployees bg-main">
    <!-- 顶部 -->
    <ld-statusbar />
    <van-row
      type="flex"
      class="setting"
      align="center"
    >
      <van-col span="10">
        <van-icon
          name="arrow-left"
          size="25"
          color="white"
          @click="onClickLeft"
        />
      </van-col>
      <van-col span="9">
        <span class="title">邀请员工</span>
      </van-col>
    </van-row>
    <!-- 顶部 END-->



    <div class="qcBody">
      <span>扫码加入企业</span>
      <div class="qrCodeBox">
        <vue-qr
          :text="invitEmpUrl"
          :correct-level="1"
          :auto-color="false"
          :size="200"
          :margin="10"
        />
        <div
          class="logoImg"
          v-show="logoUrl"
        >
          <img
            :src="logoUrl"
            alt=""
          >
        </div>
      </div>

      <div class="tipsBox">
        <h3>手机邀请码</h3>
        <p>您将含有二维码的图片分享到公司社群(如企业微信、云之家等)，您的同事可直接扫码申请</p>
      </div>
    </div>
  </div>
</template>

<script>
import {Icon,Notify,Field,NavBar } from 'vant'
import VueQr from 'vue-qr'
import ldStatusbar from 'Common/ldStatusbar'

import { mapGetters } from 'vuex'

export default {
  components: {
    VueQr,
    [Icon.name]: Icon,
    [Field.name]: Icon,
    [Notify.name]: Notify,
    [NavBar.name]: NavBar,
    ldStatusbar
  },
  data () {
    return{
      active:1,
      invitEmpUrl:'',

      corpId:'', // (string): 企业ID ,
      shortname:'', // (string): 企业名称,
      corpNo:'', // (string, optional): 企业编号
      logoUrl:'',
    }
  },
  created(){
    this.processingData()
  },
  methods:{
    processingData(){
      const {empInfo,vipCorp} = this.userInfo
      this.corpId = empInfo.corpId
      this.shortname = vipCorp.fullname
      this.corpNo = vipCorp.corpNo
      this.logoUrl = this.loginConfig.logoUrl
      const {corpId,shortname,corpNo} = this
      const data = {corpId,shortname,corpNo}
      var appurl = this.loginConfig.domainName.split(',')
      // 本地环境
      // this.invitEmpUrl = 'http://192.168.10.107:8081/#/Invitation?data='+JSON.stringify(data)
      // 生产环境
      this.invitEmpUrl = (this.loginConfig.domainName?('http://'+appurl[0]):process.env.VUE_APP_addressIp)+'/#/Invitation?data='+JSON.stringify(data)
    },
    onClickLeft(){
      this.$router.go(-1)
    },
  },
  computed:{
    ...mapGetters({
      userInfo:'userInfo',
      loginConfig:'loginConfig'
    })
  }
}
</script>

<style lang="less" scoped>
.InvitEmployees {

  height: 100%;
  .setting{

    padding:0 6px;
    height: 50px;
    .title{
      color: white;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .qcBody{
    background: white;
    border-radius: 20px;
    width: 85%;
    margin: 100px auto;
    padding-top: 30px;
    text-align: center;
    span{
      font-size: 18px;
      font-weight: 600;
    }
  }
  .qrCodeBox{
    display: flex;
    justify-content: center;
    padding-top: 20px;
    position: relative;
    .logoImg{
      position: absolute;
      width:40px;
      height:40px;
      top: 100px;
      img{
        height: 100%;
        border-radius: 10px;
        border: 3px solid white;
      }
    }
  }
  .tipsBox{
    text-align: center;
    height:100px;
    .invitEmpUrlInpu{
      width: 80%;
      height: 40px;
      margin: 5px auto;
      border: 2px dashed #767676;
      border-radius: 5px;
      color: #1a7de5;
      font-size: 18px;
    }
    p{color: #9e9e9e;}
  }
  .bottomBox{ width: 96%;margin: 40px auto;text-align: center;
   .invitationBox{
     height: 60px;
     color: #9e9e9e;
   }
  }

}
</style>
